module.exports = __webpack_public_path__ + "img/button-left-map-charts.4df1751d.png";